






















































import { apiPageConfigGetStateContentByApp } from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { requiredDeep, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '热销榜单',
        }))
      }

      loading = computed(() => false)

      handleLoad = ({ pageNumber }: any) => {
        return apiPageConfigGetStateContentByApp({
          stateId: '8aaa8fa484cbd04c01850672ceb00204',
          pageIndex: pageNumber,
          pageSize: 10,
        })
          .then(requiredDeep)
          .then(res => {
            return res.list.map(item => ({
              ...item,
              // 直降价
              // 原价减去售价，然后和0取最大值
              cutPrice: Math.max(
                +(+item.amt - +item.discountAmt).toFixed(2),
                0,
              ),
            }))
          })
      }
    },
)
